var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"authorization-container"}},[(_vm.showLogin)?_c('login'):_vm._e(),(_vm.showActivation)?_c('activation-wizard',{staticClass:"mt-2"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }